import DOMPurify from 'dompurify'
import type { NbMultiline } from './nbformat'

// eslint-disable-next-line no-control-regex -- ANSI ESC (0x1b) is the character we need to match
const ANSI_REGEX = /\x1b\[[0-9;]*[A-Za-z]/g

export function joinMultiline(value: NbMultiline | unknown | undefined): string {
  if (value === undefined || value === null) return ''
  if (Array.isArray(value)) return value.join('')
  return typeof value === 'string' ? value : String(value)
}

export function stripAnsi(text: string): string {
  return text.replace(ANSI_REGEX, '')
}

/** Same DOMPurify defaults the read-only view has always used. */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html)
}
